import { types as t } from 'mobx-state-tree';
import { AbstractQuestion } from './abstract-question.store';
import { BlankUserAnswer } from './Blank/blank-user-answer.store';
import { BlankCorrectAnswer } from './CorrectOption/_extends/blank-correct-answer.store';

export const AbstractQuestionWithBlankCorrectAnswers = AbstractQuestion.named(
  'AbstractQuestionWithBlankCorrectAnswers'
).props({
  correctAnswers: t.array(BlankCorrectAnswer),
  userAnswers: t.array(BlankUserAnswer),
});
